export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8648.36311641.jpg";